export default "__VITE_ASSET__6ebed1a9__"